import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IEncryptAction } from '../../../../ts/ServerApi/types/actionNames';
import { encryptContent, EncryptionActionType } from '../../../actions/spaces/EncryptContentAction';
import { SessionServerSelectors, SessionSiteSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const EncryptAction: IEntityAction<IContentInfo, IEncryptAction> = {
  name: 'encrypt',
  translateName: Messages.encrypt_action,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    return SessionServerSelectors.extractEncryptionEnabledOmniSwitch(appState) && SessionSiteSelectors.isSiteEARModeEnabled(appState) && !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IEncryptAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.encryptExtracts);
  },
  createReduxAction: (targetItems: IContentInfo[]) => encryptContent(targetItems, EncryptionActionType.encryptExtracts)
};
